import React, { memo, useState } from 'react';

// Create a separate Search component to avoid re-rendering issues
export const GlobalSearch = memo(({ onSearchChange }) => {
  const [searchText, setSearchText] = useState('');

  const handleChange = (e) => {
    const newValue = e.target.value;
    setSearchText(newValue);
    onSearchChange(newValue);
  };

  return (
    <div className="inputColor d-flex align-items-center rounded-5 px-2" >
      <input
        type="text"
        className={`d-flex justify-content-center border-0 bg-transparent text-muted flex-grow-1 px-4 no-border`}
        placeholder="Search across all fields..."
        aria-label="Search"
        value={searchText}
        onChange={handleChange}
        style={{ outline: 'none' }}
      />
      <button className="border-0 bg-transparent text-dark ms-2 me-2">
        <i className="fa-solid fa-magnifying-glass"></i>
      </button>
    </div>
  );
});